import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService, AlertService } from '../_services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, private alertService: AlertService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            let error;
            if (err.status >= 400 && err.status < 500) {
                this.authenticationService.logout();
                error = '<h3>Acceso denegado</h3>No puede ver esto.';
            } else {
                error = '<h3>Ups</h3>Algo salio mal.';
            }
            this.alertService.error(error);
            return throwError(error);
        }));
    }
}
